import { render, staticRenderFns } from "./IApple.vue?vue&type=template&id=6932f09f&"
import script from "./IApple.vue?vue&type=script&lang=ts&"
export * from "./IApple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports